export enum DurationEnm {
  "Half" = 12,
  "Full" = 24,
}
export enum DonationTypes {
  "Once" = "once",
  "Monthly" = "monthly",
}